<template>
  <SharePopoverBase
    :is-popover-open="isPopoverOpen"
    :is-loading-share-button="isLoadingShareButton"
    :has-selected-options="hasSelectedOptions"
    :selected-options="selectedOptions"
    @toggle-popover="togglePopover"
    @close-popover="closePopover"
    @capture-charts="captureCharts"
    @generate-csv="generateCSV">
    <template #options="{ selectedOptions }">
      <!-- Checkboxes dinâmicos para cada sensor -->
      <div v-if="availableOptions.length > 0" class="mb-4">
        <div v-for="option in availableOptions" :key="option.id" class="mb-3">
          <div class="flex items-center justify-between">
            <label class="flex items-center">
              <input type="checkbox" v-model="selectedOptions[option.id]" class="mr-2 border-gray-300 text-blue-600 focus:ring-blue-500" />
              <span class="text-sm text-gray-700">{{ option.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </template>
  </SharePopoverBase>
</template>

<script setup lang="ts">
import SharePopoverBase from '@/components/Globals/SharePopoverBase.vue'
import { useRegistersShare } from '@/composables/useRegistersShare'

const { isPopoverOpen, isLoadingShareButton, hasSelectedOptions, selectedOptions, availableOptions, togglePopover, closePopover, captureCharts, generateCSV } =
  useRegistersShare()
</script>
